// extracted by mini-css-extract-plugin
module.exports = {"title":"Tabs_title__xzu3b","active":"Tabs_active__AsLTM","content":"Tabs_content__1kXFP"};